import styled, { css } from 'styled-components'

export const FlatListContainer = styled.div`
  display: flex;
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.colors.background};
  `}
`

export const Shadow = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.foreground};
`

export const FlatListButton = styled.button`
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
`

export const DayOfTheWeekLabel = styled.span`
  ${({ theme }) => css`
    font-size: 21px;
    color: ${theme.colors.text};
    font-family: ${theme.fonts.title};
    font-weight: ${theme.fonts.titleWeight};
  `};
`

export const SelectionLine = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 2px;
    background-color: ${theme.colors.text};
  `};
`

export const WeekListRow = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
`
